module.exports = __webpack_public_path__ + "static/media/instore.3ce3e51d.svg";